{
    "AdminControl_PolicyApplied": "Angewandte Richtlinie",
    "AdminControl_RecordingPolicyDetails": "Details zur Aufzeichnungsrichtlinie",
    "AdminControl_DisplayName": "Anzeigename:",
    "AdminControl_UserPrincipalName": "Benutzerprinzipalname",
    "AdminControl_TeamsComplianceRecordingPolicy": "Richtlinien zur Teamkonformität bei der Aufzeichnung",
    "AdminControl_PresenceStatus": "Anwesenheitsstatus",
    "AdminControl_CopiedToClipboard": "In die Zwischenablage kopiert",
    "AdminControl_ResponseSuccess": "Aufgabe erfolgreich abgeschlossen",
    "NAME": "AdminControlLanguage"
}